import { createI18n } from 'vue-i18n'
import ZhCn from "./zh-cn"
import EnUs from "./en-us"

const i18n = createI18n({
    locale: "zh-cn",
    messages: {
        "zh-cn": ZhCn,
        "en-us": EnUs
    }
})

export default i18n;